module.exports = __webpack_public_path__ + "static/media/anage-select-branco.5fab1bbc.svg";